import PropTypes from 'prop-types'
import { formatEmptyValue } from '../../../utils/common'
import Tooltip from '../../common/tooltip'

const GraphMissingImagesRow = (props) => {
  return (
    <div className="flex flex-row flex-wrap items-center bg-white w-full py-2 px-3 border-b border-tracer-dark-blue text-black">
      <div className="flex flex-row w-full">
        <div className="flex w-2/12 pl-10 items-center table_text">
          <Tooltip message={props?.component_id}>
            <div>{formatEmptyValue(props.component_id)}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          <Tooltip message={props?.component_desc}>
            <div>{formatEmptyValue(props.component_desc)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.harness}>
            <div>{formatEmptyValue(props.harness)}</div>
          </Tooltip>
        </div>
        <div className="flex w-2/12 pl-6 items-center table_text">
          <Tooltip message={props?.vin}>
            <div>{formatEmptyValue(props.vin)}</div>
          </Tooltip>
        </div>
        <div className="flex w-1/12 pl-6 items-center table_text">
          <Tooltip message={props?.category}>
            <div>{formatEmptyValue(props.category)}</div>
          </Tooltip>
        </div>
        <div className="flex w-3/12 pl-6 items-center table_text">
          <Tooltip message={props?.is_missing_connector_or_terminal_img}>
            <div>
              Connector Or Terminal :{' '}
              {props.is_missing_connector_or_terminal_img}
            </div>
            <div> Vehicle : {props.is_missing_vehicle_img}</div>
          </Tooltip>
        </div>
      </div>
    </div>
  )
}

GraphMissingImagesRow.propTypes = {
  component_id: PropTypes.string.isRequired,
  dtc: PropTypes.string.isRequired,
  dtc_description: PropTypes.string.isRequired,
  connectors_mapped_successfully: PropTypes.string.isRequired,
  data_version: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}

export default GraphMissingImagesRow
